
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("ivYay", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2be32452f9da0b22$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $2be32452f9da0b22$export$2e2bcd8739ae039 = {
    'identity.account-menu.account-details.manage-profile-link': "Configura\xe7\xf5es da conta",
    'identity.account-menu.account-details.view-profile-tooltip': 'Perfil',
    'identity.account-menu.account-menu-content.log-out-button': 'Sair',
    'identity.account-menu.account-menu-content.switch-account-button': 'Trocar de conta',
    'identity.account-menu.account-menu-details.managed-account': "Essa conta \xe9 gerenciada por <b>{managedBy}</b>",
    'identity.account-menu.account-menu-logged-out-state.log-in': 'Entrar',
    'identity.account-menu.account-menu-popup.skeleton.tooltip': 'Conta',
    'identity.account-menu.theme-switcher.dark.option': 'Escuro',
    'identity.account-menu.theme-switcher.light.option': 'Claro',
    'identity.account-menu.theme-switcher.match-browser.option': 'Corresponder ao navegador',
    'identity.account-menu.theme-switcher.theme-button': 'Tema'
};

});


//# sourceMappingURL=pt_BR.15e39ce9.js.map
